export enum ClientDeviceType {
  DESKTOP = "client-desk",
  WEB = "client-web",
  PHONE = "client-phone",
  TABLET = "client-tablet",
  TV = "client-tv",
}

export interface UserAgent {
  apiVersion?: string;
  client: ClientDeviceType;
  clientVersion: string;
  // TODO extract enum !
  os:
    | "Android"
    | "iOS"
    | "Fireos"
    | "Linux"
    | "Mac"
    | "Tizen"
    | "Windows"
    | "Webos"
    | "Vidaa"
    | "Hisense";
  deviceType: "DESKTOP" | "MOBILE" | "TABLET" | "TV";
  androidVersion?: string;
  brand?: string;
  model?: string;
  modelName?: string;
  flavor?: string /* Cliq, ... */;
}

export const createUserAgentString = (params: UserAgent) => {
  const androidVersionStr = params.androidVersion || "";
  const brandStr = params.brand || "";
  const modelStr = params.model || "";
  const modelNameStr = params.modelName || "";
  let fullModelStr = `${brandStr.replace(/_/g, "-")}/${modelStr.replace(
    /_/g,
    "-",
  )}/${modelNameStr.replace(/_/g, "-")}`;
  if (fullModelStr === "//") {
    fullModelStr = "";
  }
  return `Blacknut/${params.apiVersion || "5.0.2"} ${params.client}/${
    params.clientVersion
  } (${params.os};${params.deviceType};${androidVersionStr};${fullModelStr})`.replace(
    /\s{1,}/g /*Remove multi space*/,
    " ",
  );
};
